import fixtures from './fixtures/filter_fixtures.json'
import 'util'
import Slugify from 'slugify'

let utils = {
  banks: fixtures.banks,
  years: fixtures.years,
  prices: fixtures.prices,
  kilometers: fixtures.kilometers,
  makers: fixtures.makersWithModels,
  makersAvailable: fixtures.makersAvailable,
  provinces: fixtures.provinces,
  fuelTypes: fixtures.fuelTypes,
  colors: fixtures.colors.filter(color => color.name.trim() !== ''),
  bodyworks: fixtures.bodyworks,
  transmissions: fixtures.transmissions,
  horsePower: fixtures.horsepower,
  carTypes: fixtures.carTypes,
  carStatuses: fixtures.carStatuses,
  dealerships: fixtures.dealerships,

  categories: [{id: 0, name: 'Todos'}, {id: 1, name: 'Nuevo'}, {id: 2, name: 'Km0'}, {id: 6, name: 'Ocasión'}],

  officialBanks: () => utils.banks.filter(bank => bank.isOfficial),

  categoryById: categoryId => utils.categories.find(el => el.id === categoryId),
  modelsByMaker: makerId => fixtures.makersWithModels.find(maker => maker.id === makerId).models,

  makerNameById: makerId => fixtures.makersWithModels.find(maker => maker.id === makerId).name,
  makerById: makerId => fixtures.makersWithModels.find(maker => maker.id === makerId),

  provinceNameById: provinceId => fixtures.provinces.find(province => province.id === provinceId).name,
  provinceById: provinceId => fixtures.provinces.find(province => province.id === provinceId),

  fueltypeNameById: fueltypeId => fixtures.fuelTypes.find(fuelType => fuelType.id === fueltypeId).name,
  fueltypeById: fueltypeId => fixtures.fuelTypes.find(fuelType => fuelType.id === fueltypeId),

  colorNameById: colorId => utils.colors.find(color => color.id === colorId).name,
  colorById: colorId => utils.colors.find(color => color.id === colorId),

  bodyworkNameById: bodyworkId => fixtures.bodyworks.find(bodywork => bodywork.id === bodyworkId).name,
  bodyworkById: bodyworkId => fixtures.bodyworks.find(bodywork => bodywork.id === bodyworkId),

  transmissionNameById: transmissionId => fixtures.transmissions.find(transmission => transmission.id === transmissionId).name,
  transmissionById: transmissionId => fixtures.transmissions.find(transmission => transmission.id === transmissionId),

  truncateText: (text, length) => (text.length > length) ? text.substr(0, length - 1) + '…' : text,

  modelNameById: (modelId) => fixtures.makersWithModels
    .map(maker => maker.models.find(model => model.id === modelId)) // map to Array<Model?>
    .find(i => i != null) // Firs not null
    .name,
  maptagsFromDescriptionTags: descriptionTags => descriptionTags.map(tagDescription => {
    let mapped = Object.assign({
      shortDescription: utils.truncateText(tagDescription.description, 50),
      raw: tagDescription,
      tags: []
    }, tagDescription)

    function strip (html) {
      var tmp = document.createElement('DIV')
      tmp.innerHTML = html
      return tmp.textContent || tmp.innerText || ''
    }

    mapped.shortDescription = strip(mapped.shortDescription)

    for (let key in tagDescription) {
      // noinspection JSUnfilteredForInLoop
      let property = tagDescription[key]
      if (property != null && key !== 'id' && key !== 'description') {
        // noinspection JSUnfilteredForInLoop
        switch (key) {
          case 'makerId':
            mapped.tags.push({
              id: property,
              value: utils.makerNameById(property)
            })
            break
          case 'modelId':
            mapped.tags.push({
              id: property,
              value: utils.modelNameById(property)
            })
            break
          case 'provinceId':
            mapped.tags.push({
              id: property,
              value: utils.provinceNameById(property)
            })
            break
          case 'fueltypeId':
            mapped.tags.push({
              id: property,
              value: utils.fueltypeNameById(property)
            })
            break
          case 'colorId':
            mapped.tags.push({
              id: property,
              value: utils.colorNameById(property)
            })
            break
          case 'bodyworkId':
            mapped.tags.push({
              id: property,
              value: utils.bodyworkNameById(property)
            })
            break
          case 'transmissionId':
            mapped.tags.push({
              id: property,
              value: utils.transmissionNameById(property)
            })
            break
        }
      }
    }

    return mapped
  }),

  urlFromSectionFiltersPageAndSort (publicationType, filters, page, sort) {
    if (page === undefined) {
      page = null
    }
    if (sort === undefined) {
      sort = null
    }

    let urlTemplate = ''

    let pushFilter = value => {
      urlTemplate += '/' + Slugify(value, { lower: true })
    }

    if (filters.maker != null) {
      pushFilter(utils.makerNameById(filters.maker))

      if (filters.model != null) {
        pushFilter(utils.modelNameById(filters.model))
      }
    }

    if (filters.transmission !== null && filters.transmission !== undefined) {
      pushFilter(utils.transmissionNameById(filters.transmission))
    }

    if (filters.fuelType !== null && filters.fuelType !== undefined) {
      pushFilter(utils.fueltypeNameById(filters.fuelType))
    }

    if (filters.color !== null && filters.color !== undefined) {
      pushFilter(utils.colorNameById(filters.color))
    }

    if (filters.price !== null && filters.price !== undefined) {
      pushFilter(`Hasta ${filters.price} euros`)
    }

    if (filters.kilometers !== null && filters.kilometers !== undefined) {
      pushFilter(`Hasta ${filters.kilometers} kilometros`)
    }

    if (filters.horsePower !== null && filters.horsePower !== undefined) {
      pushFilter(`Hasta ${filters.horsePower} CV`)
    }

    if (filters.province !== null && filters.province !== undefined) {
      pushFilter(`En ${utils.provinceNameById(filters.province)}`)
    }

    if (filters.year !== null && filters.year !== undefined) {
      pushFilter(`Matriculado antes de ${filters.year}`)
    }

    if (filters.bodyworks !== null && filters.bodyworks !== undefined) {
      filters.bodyworks.forEach(bodyworkId => pushFilter(`Carrocería ${utils.bodyworkNameById(bodyworkId)}`))
    }

    if (filters.doors !== null && filters.doors !== undefined) {
      filters.doors.forEach(doors => pushFilter(`${doors} Puertas`))
    }
    urlTemplate = `/${publicationType}${urlTemplate}`
    if (sort !== 'default' && sort !== null) {
      urlTemplate += `?sort=${sort}`
      if (page != null && page > 0) {
        urlTemplate += `&p=${page}`
      }
    } else {
      if (page != null && page > 0) {
        urlTemplate += `?p=${page}`
      }
    }
    return urlTemplate
  }
}

export default utils



// WEBPACK FOOTER //
// ./src/utils/util.js